import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {Button, Typography, Paper, Box} from '@mui/material';
import Header from "../Common/Header/Header";
import Sidenav from "../Common/Sidenav/Sidenav";
import router from "../../routePaths/routePaths";

export default function SelectProfile() {
    let navigate = useNavigate();
    const {domain} = useParams()

    return (
        <div>
            <Header />
            <div className="main-container my-3">
                <div className="row m-2">
                    <div className="col-lg-2 col-xl-2 d-none d-lg-block d-xl-block">
                        <Sidenav/>
                    </div>
                    <div className="col-lg-10 col-xl-10">
                        <Paper elevation={2} sx={{ width: '100%', p: 3}}>
                            <div classNmae="row">
                                <Typography>
                                    Please select profile
                                </Typography>
                            </div>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: {
                                    xs: '1fr',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(4, 1fr)',
                                    },
                                    gap: 2,
                                    pt: 2
                                }}
                            >
                                <Button className="btn btn-blue" onClick={()=>navigate(router.update_rate+'/'+domain)}>
                                    Configure rate
                                </Button>
                                <Button className="btn btn-blue" onClick={()=>navigate(router.button_to_wheel+'/'+domain)}>
                                    Convert buttons to time wheel
                                </Button>
                                <Button className="btn btn-blue" onClick={()=>navigate(router.monthly_permit+'/'+domain)}>
                                    Monthly Permits
                                </Button>
                                <Button className="btn btn-blue" onClick={()=>navigate(router.disable_zone+'/'+domain)}>
                                    Disable a zone
                                </Button>
                                <Button className="btn btn-blue" onClick={()=>navigate(router.enable_zone+'/'+domain)}>
                                    Enable a zone
                                </Button>
                                <Button className="btn btn-blue" onClick={()=>navigate(router.add_door_code+'/'+domain)}>
                                    Add/Update Door Code
                                </Button>
                                <Button className="btn btn-blue" onClick={()=>navigate(router.parameters+'/'+domain)}>
                                    Parameters
                                </Button>
                                <Button className="btn btn-blue" onClick={()=>navigate(router.enforcement_zone+'/'+domain)}>
                                    Add Enforcement Zone
                                </Button>
                            </Box>
                            <div className="row">
                            </div>
                        </Paper>
                    </div>
                </div>
            </div>
        </div>
    );
}
